import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

function Register() {
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = {
        username: form.username.value,
        email: form.email.value,
        password: form.password.value,
        role: "USER",
    };

    try {
    const url = `${process.env.REACT_APP_API_BASE_URL}unito/register`;
    // console.log("Sending POST to:", url);
    // console.log("Payload:", data);

    const response = await axios.post(url, data, {
        headers: {
            "Content-Type": "application/json",
        }
    });

    console.log("Response received:", response);

    if (response.status >= 200 && response.status < 300) {
        console.log(response);
        alert("Registered successfully!");
        navigate('/profile');
    } else {
        alert("Registration failed")
        console.log(response);
        console.warn("Unexpected response status:", response.status);
    }
} catch (error) {
    console.error("Error:", error);
    alert("An error occurred during registration.");
}
};

    return (
        <>
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-violet-300 to-pink-300">
            <div className="bg-white shadow-xl rounded-lg p-10 w-full max-w-md">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">
                    Create Your Account
                </h2>
                <p className="text-center text-gray-500 mb-6">
                    Dive into the Unknown 🚀
                </p>

                <form method="POST" onSubmit={handleSubmit} action="/unito/register" className="space-y-5">
                    <div>
                        <label htmlFor="username" className="block text-sm font-semibold text-gray-700 mb-1">
                            Username
                        </label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            required
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-1">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            required
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-violet-500 hover:bg-violet-600 text-white font-semibold py-2 rounded-md transition duration-200"
                    >
                        Register
                    </button>
                </form>

                <p className="text-sm text-center text-gray-500 mt-6">
                    Already have an account?{" "}
                    <Link to="/login" className="text-violet-600 hover:underline">
                        Login here
                    </Link>
                </p>
            </div>
        </div>
        </>
    );
}

export default Register;
